export const languageSelectorValidForRegion = true;
